import { authHttp } from '../http'
import * as routes from '../../routes/registration.routes'
import { errorHandler } from '../../../util/error.service'

export async function saveMotorista(motorista) {
  try {
    const response = await authHttp().post(routes.urlPostMotorista, motorista)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
export async function getMotoristas(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetMotoristas(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
